// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"4d99ab32","459":"abd6e927"}[chunkId] + ".chunk.css";
};